<div class="editable" [class.editable--case]="asCase">
  <div class="editable__field">
    <label *ngIf="label" class="text-field__label">{{label}}</label>
    <input #editableInputField (input)="writeValue($event.target.value)" [value]="value" type="text" class="editable__field__value" [attr.aria-label]="'Edytuj ' + label">
  </div>
  <button (click)="cancel()" type="button" mat-ripple class="editable__action--cancel" [attr.aria-label]="'Anuluj zmianę ' + label"></button>
  <button (click)="accept()" type="button" mat-ripple class="editable__action--confirm" [attr.aria-label]="'Zatwierdź zmianę ' + label"></button>
</div>
